export const DEFAULT_PER_PAGE = 20;

export interface PageMeta {
  page: number;
  per_page: number;
  total: number;
}

// Бэк не отдаёт has_next — считаем по total.
export const getNextPage = ({
  page,
  per_page,
  total,
}: PageMeta): number | undefined =>
  page * per_page < total ? page + 1 : undefined;
